import React from "react";
import CookiesConsent from "react-cookie-consent";
const CookiesNotices = () => {
  return (
    <div className="w-3/12">
      <CookiesConsent
        // debug={true}
        expires={365}
        style={{
          width: "25rem",
          marginLeft: "1rem",
          marginBottom: "0.5rem",
          borderRadius: "5px",
          background: "#121317",
          color: "white",
        }}
        buttonStyle={{ backgroundColor: "#e19e08", color: "white"}}
      >
        This website uses cookies to ensure you{" "}
        <span className="text-white" style={{color:"#e19e08"}}>get the best experience on our website.</span>
      </CookiesConsent>
    </div>
  );
};

export default CookiesNotices;
